<template>
	<div id="multiselectnote">
		<div class="dropdown dropdown-filter" @click="showDropdown">
			<div class="overselect"></div>
			<div class="c-form-input">
				<h3 class="raleway-semi-p13">Type d’établissement</h3>
				<img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
				<img src="../../images/flechebas-simple.svg" v-set-alt v-else />
			</div>
		</div>
		<div class="multiselect" v-if="show">
			<ul>
				<div class="row-selectoptions mt-3" :class="{ row: !isPhone }">
					<div :class="{ 'col-10': !isPhone }">
						<li>
							<input type="checkbox" id="hotel" value="Hotel" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="hotel">
								Hôtels <span class="filter-count">({{ getTypeCount('Hotel') || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="maison-villa" value="Maison et Villa" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="maison-villa">
								Maisons et Villas <span class="filter-count">({{ getTypeCount('Maison et Villa') || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="guestroom" value="Guestroom" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="guestroom">
								Chambres d'Hôtes <span class="filter-count">({{ getTypeCount('Guestroom') || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="lodge" value="Lodge" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="lodge">
								Lodges et Lieux Insolites <span class="filter-count">({{ getTypeCount('Lodge') || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="chalet" value="Chalet" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="chalet">
								Chalets <span class="filter-count">({{ getTypeCount('Chalet') || 0 }})</span>
							</label>
						</li>

						<li>
							<input type="checkbox" id="appartement" value="Appartment" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="appartement">
								Appartements <span class="filter-count">({{ getTypeCount('Appartment') || 0 }})</span>
							</label>
						</li>
<!--						<li>-->
<!--							<input type="checkbox" id="guestroom" value="Guestroom" v-model="selected" />-->
<!--							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="guestroom">Chambres d’hôtes</label>-->
<!--						</li>-->
<!--						<li>-->
<!--							<input type="checkbox" id="gite" value="Gite" v-model="selected" />-->
<!--							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="gite">Gîtes</label>-->
<!--						</li>-->
						<!-- <li>
							<input type="checkbox" id="other" value="Other" v-model="selected" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="other">Lieux insolites</label>
						</li> -->
					</div>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
	import fetcher from 'packs/shared/api.js';

	export default {
		name: 'multiselectnote',
		props: ['options', 'filterCounts'],
		data() {
			return {
				show: false,
				selected: [],
				// lodgingsMount: null,
				// typesMount: [],
			};
		},
		methods: {
			showDropdown() {
				this.show = !this.show;
			},
			getTypeCount(type) {
				if (!this.filterCounts || !this.filterCounts.type) return 0;
				const typeData = this.filterCounts.type.find(t => t.key === type);
				return typeData ? typeData.count : 0;
			},
			// async fetchTypes() {
			//      try {
			//        const response = await fetcher.get('lodgings.json');
			//          this.lodgingsMount = response.data
			//          this.lodgingsMount.forEach((lodging) => {
			//             return this.typesMount.push(lodging.type)
			//          })
			//      } catch(e) {
			//        console.error(e);
			//      }
			//    },
		},
		//   beforeMount() {
		//   this.fetchTypes();
		// },
		watch: {
			selected(val) {
				let types = new Set(val);

				const typeMap = {
				'Maison et Villa': [],
				'Guestroom': [],
				'Lodge': [],
				'Chalet': []
				};

				val.forEach((selectedType) => {
				if (typeMap[selectedType]) {
					typeMap[selectedType].forEach(mapped => types.add(mapped));
				}
				});

				// No additional type mapping needed since we've consolidated the types

				this.$emit('checked', Array.from(types), 'type');
			},
		},
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        } else {
          return false;
        }
      },
    }
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
